<template>
  <div class="pa-4 mb-8">
    <v-row justify="center">
      <h2 class="display-1 pb-4">{{ step.title }}</h2>
      <v-col cols="8">
        {{ step.description }}
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="10" class="pb-0">
        <v-expansion-panels accordion popout flat hover :value="0">
          <v-expansion-panel v-for="(concern, cIndex) in concerns" :key="concern.text">
            <v-expansion-panel-header class="justify-left">
              <v-icon
                v-if="concern.questions && concern.questions.length"
                class="shrink mr-4 blue--text"
              >
                check_circle
              </v-icon>
              <v-icon v-else class="shrink mr-4 grey--text text--lighten-2">brightness_1</v-icon>
              {{ concern.text }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12" class="py-0">
                  <v-list class="py-0" style="height: 200px; overflow-y: auto; overflow-x: hidden;">
                    <v-slide-y-transition group leave-absolute>
                      <template v-for="(item, n) in sugArray(cIndex)">
                        <v-list-item
                          v-if="item.type == 'suggestion'"
                          :key="item.text"
                          @click="addSuggestion(item, cIndex)"
                          style="opacity: 0.6; width: 430px;"
                        >
                          <v-list-item-icon><v-icon small>add</v-icon></v-list-item-icon>
                          <v-list-item-title>{{ item.text }}</v-list-item-title>
                          <v-list-item-action @click.stop="removeSuggestion(item, cIndex)">
                            <v-btn icon small><v-icon small>close</v-icon></v-btn>
                          </v-list-item-action>
                        </v-list-item>
                        <v-list-item v-else :key="item.text" style="width: 430px;">
                          <v-list-item-subtitle class="font-weight-bold">{{
                            item.text
                          }}</v-list-item-subtitle>
                          <v-list-item-action @click.stop="removeQuestion(item, cIndex)">
                            <v-btn icon small><v-icon small>close</v-icon></v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </template>
                    </v-slide-y-transition>
                  </v-list>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col class="pt-0">
                  <v-text-field
                    v-model="newQuestion"
                    autofocus
                    hide-details
                    :placeholder="step.placeholder"
                    @keypress.enter="
                      concerns[cIndex].questions.push({ text: newQuestion });
                      newQuestion = '';
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col class="caption">
                  <p class="mb-0"><strong>Tip: </strong>{{ step.tip }}</p>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ['step', 'value'],
  data() {
    return {
      suggestions: [],
      newQuestion: '',
      concerns: []
    };
  },
  watch: {
    concerns: function(n) {
      if (this.concerns != this.value) {
        console.log('update');
        this.$emit('input', n);
      }
    },
    value: function(n) {
      this.concerns = n;
    }
  },
  computed: {},
  methods: {
    sugArray(cIndex) {
      const result = this.concerns[cIndex].questions.map(c => ({ ...c, type: 'concern' }));
      return result.concat(
        this.concerns[cIndex].qSuggestions.map(s => ({ text: s, type: 'suggestion' }))
      );
    },
    addSuggestion(s, cIndex) {
      this.concerns[cIndex].questions.push({ text: s.text });
      const n = this.concerns[cIndex].qSuggestions.findIndex(con => con == s.text);
      this.concerns[cIndex].qSuggestions.splice(n, 1);
    },
    removeQuestion(item, cIndex) {
      const n = this.concerns[cIndex].questions.findIndex(con => con.text == item.text);
      this.concerns[cIndex].questions.splice(n, 1);
    },
    removeSuggestion(s, cIndex) {
      const n = this.concerns[cIndex].qSuggestions.findIndex(con => con == s.text);
      this.concerns[cIndex].qSuggestions.splice(n, 1);
    }
  }
};
</script>

<style></style>
